import { Injectable } from '@angular/core';

import {BehaviorSubject, Observable } from 'rxjs';

import {Map, LayerGroup, Marker, LatLng, Icon, FeatureGroup, DivIcon, CRS, Popup, latLng} from 'leaflet';
import { Cluster } from '../../../../models/map/Cluster';
import { MapConfigService } from '../../config/map-config.service';
import { VehicleStatusEnum } from '../../../../models/domain/VehicleStatusEnum';
import { Consts } from '../../../../consts/consts';

/**
 * Provides map drawing utilities
 */
@Injectable()
export class ClusterDrawerService {

    /**
     * marker events
     */
    private markerEvents: BehaviorSubject<any> = new BehaviorSubject(null);

    /**
     * Popup marker
     */
    private popup?: Popup;

    /**
     * Halo marker
     */
    private halo?: Marker;


    /**
     * biezace elementy
     */
    // private elements: any = {};

    /**
     * Ostatni wyswietlany kluster -  możliwe, że do usuniecia
     */
    private currentClusterId?: number;

    /**
     * Timeout dla pojawiania i wygaszania popup
     */
    private popupTimeout: any;

    /**
     * Constructor of draw service
     * @param $cluster cluster service
     */
    public constructor(
        private $mapConfig: MapConfigService
    ) {
    }

    isDrawed = 0;


    /**
     * Draw clusters
     * @param clusters array of clusters
     * @param group layer group
     * @param map map
     */
    public draw(clusters: Cluster[], map: Map): FeatureGroup {

        // kopia
        const group = new FeatureGroup();
        // this.elements = [];

        // Remove old clusters and halo marker
        if (this.halo != null) {
            this.halo.remove();
        }

        // Get new cluster id array
        // const clusterIds = clusters.map(i => i.getClusterPK().toString());
        // const currentClusterIds = Object.keys(this.elements);

        // // usuniecie starych klastrow
        // currentClusterIds.forEach(id => {
        //     if (clusterIds.indexOf(id) === -1) {
        //         this.elements[id].forEach(l => group.removeLayer(l));
        //         delete this.elements[id];
        //     }
        // });

        // Draw new ones

        var properClusters = clusters;
        var currentVehicleCluster = clusters.find(c => c.pointCount > 1 && c.points.some(p => p.properties.Id == this.$mapConfig.getCurrentVehicleId()));

        if (currentVehicleCluster && currentVehicleCluster.pointCount > 1) {
            properClusters = clusters.filter(c => c != currentVehicleCluster);

            var vehiclePoint = currentVehicleCluster.points.find(p => p.properties.Id === this.$mapConfig.getCurrentVehicleId());
            var trimmedCluster = currentVehicleCluster;
            trimmedCluster.points = currentVehicleCluster.points.filter(p => p != vehiclePoint);

            var trackedVehicleCluster = new Cluster(vehiclePoint!.lat, vehiclePoint!.lng);
            trackedVehicleCluster.properties = vehiclePoint!.properties;
            trackedVehicleCluster.points.push(vehiclePoint!);

            properClusters.push(trackedVehicleCluster, trimmedCluster);

            (<any>window).CLUSTERS[trackedVehicleCluster.getClusterPK()] = trackedVehicleCluster;
        }

        for (const cluster of properClusters) {

            // Check whether cluster has multiple points
            if (cluster.pointCount > 1) {
                // Draw vehicle cluster
                this.drawVehicleCluster(cluster, group, map);
            } else {
                // Draw vehicle
                this.drawVehicle(cluster, group, map);
            }
        }

        // wymiana group
        return group;
    }

    public getMarkerEventsStream(): Observable<any> {
        return this.markerEvents.asObservable();
    }

    /**
     * Draws vehicles' cluster on the map within given layer group
     * @param cluster cluster to draw
     * @param group layer group
     * @param map map object
     */
    private drawVehicleCluster(cluster: Cluster, group: LayerGroup, map: Map, options?: any): void {

        // Check with which statuses are vehicle in cluster
        const colorsBits = new Set<number>();
        for (const point of cluster.points) {
            colorsBits.add(this.getStatusColour(point.properties.VehicleStatus));
        }

        // Add all of the statuses to get number of icon to display
        let sum = 0;
        colorsBits.forEach(color => {
            sum += color;
        });

        const onClick = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'click', type: 'group', clusterId: clusterId });
        };

        const onMouseOver = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'mouseover', type: 'group', clusterId: clusterId });
        };

        const onMouseOut = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'mouseout', type: 'group', clusterId: clusterId });
        };

        // 2. Number marker
        const elementId = `${cluster.getClusterPK()}`;
        const iconHtml = `
        <div class="cluster-element-info cluster-element-info-${sum}" id="${elementId}">
        <div class="cluster-element-count">
        ${cluster.pointCount.toString()}
        </div>
        </div>`;

        const numIcon = new DivIcon({
            'html': iconHtml,
            // 'iconSize': [8, 16],
            // 'iconAnchor': [Math.pow(cluster.pointCount.toString().length, 1.05) * 5, 11]
            // little bit of math magic to allign text value accordingly to number of digits
        });

        // extend
        const _Marker = Marker.extend({ options: { Cluster: undefined, clusterId: undefined } });

        //TODO GB może przypisanie lat i lang powinno być do cluster z dużej litery
        let number_marker = new _Marker();
        number_marker.setLatLng([cluster.lat, cluster.lng]);
        number_marker.options.icon = numIcon;
        number_marker.options.clusterId = cluster.getClusterPK();
        number_marker.options.Cluster = cluster;

        number_marker.addTo(group);

        number_marker.on('click', onClick);

        number_marker.on('mouseover', onMouseOver);

        number_marker.on('mouseout', onMouseOut);

    }

    getStatusColour(status: VehicleStatusEnum): number {
        const vehSettings = Consts.VehicleSettingsByStatusMap.get(status);
        return vehSettings ? vehSettings.groupMarkerColor : 0;
    }

    /**
     * Draws vehicle on the map within given layer group
     * @param cluster cluster to draw
     * @param group layer group
     */
    private drawVehicle(cluster: Cluster, group: LayerGroup, map: Map, options?: any): void {
        let pointProperties;
        let lng, lat;

        if (cluster.clusterId) {
            pointProperties = cluster.points[0].properties;
            lng = cluster.points[0].lng;
            lat = cluster.points[0].lat;
        }
        else {
            pointProperties = cluster.properties;
            lng = cluster.lng;
            lat = cluster.lat;
        }

        // // Get element from history
        const elementId = pointProperties.Id;
        let vehicle_marker;

        // Vehicle marker
        const angle = pointProperties.VehicleAngle;
        // const status = MappingService.convertVehicleStatus(pointProperties.VehicleStatus);

        // Events
        const onMouseOver = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'mouseover', type: 'vehicle', clusterId: clusterId });
        };

        const onMouseOut = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'mouseout', type: 'vehicle', clusterId: clusterId });
        };

        const onClick = (event: any) => {
            // przeslanie eventa
            const clusterId = event.target.options.Cluster.getClusterPK();
            this.markerEvents.next({ event: 'click', type: 'vehicle', clusterId: clusterId });
        };

        // czy popupy wlaczone
        const isPopupVisible = this.$mapConfig.getShowPopupsFlag();

        // sprawdznie czy dany
        const currentVehicleId = this.$mapConfig.getCurrentVehicleId();
        let isCurrentVehicle = false;
        if (currentVehicleId === Math.abs(elementId)) {
            isCurrentVehicle = true;
        }

        const icon = this.getRotatableIcon(elementId, pointProperties.VehicleStatus, angle, isCurrentVehicle);

        // extend
        const _Marker = Marker.extend({
            options: {
                VehicleId: undefined,
                Cluster: undefined,
                clusterId: undefined,
                isPopupVisible: undefined,
                isCurrentVehicle: undefined,
            }
        });

      //TODO GB może przypisanie lat i lang powinno być do cluster z dużej litery
       vehicle_marker = new _Marker();
        vehicle_marker.setLatLng([lat, lng]);
        vehicle_marker.options.icon = icon;
        vehicle_marker.options.keyboard = false;
        vehicle_marker.options.riseOnHover = true;
        vehicle_marker.options.VehicleId = elementId;
        vehicle_marker.options.Cluster = cluster;
        vehicle_marker.options.clusterId = cluster.getClusterPK();
        vehicle_marker.options.isPopupVisible = isPopupVisible;
        vehicle_marker.options.isCurrentVehicle = isCurrentVehicle;

        if (currentVehicleId && currentVehicleId === cluster.properties.Id) {
            vehicle_marker.setZIndexOffset(1000);
        }

        vehicle_marker.addTo(group);

        vehicle_marker.on('click', onClick);

        vehicle_marker.on('mouseover', onMouseOver);

        vehicle_marker.on('mouseout', onMouseOut);
    }


    /**
     * Creates and returns rotatable marker
     * @param url url of icon
     * @param width width of marker
     * @param height height of marker
     * @param angle rotation angle in degrees
     */
    private getRotatableIcon(id: number, status: number, angle: number, isSelected: boolean): DivIcon {
        angle = angle || 0;

        const isSelectedClass = (isSelected === true) ? 'vehicle-marker-selected' : '';

        let markerNumber = this.getStatusMarker(status);

        // ikona
        const icon = new DivIcon({
            'html': `
            <div class="vehicle-marker vehicle-marker-${markerNumber} ${isSelectedClass}" id="${id}">
            <div class="vehicle-marker-content">
            <div class="vehicle-marker-image-selected">
                <div class="vehicle-marker-image-selected-content">
                </div>
            </div>
            <div class="vehicle-marker-image" style="
                        transform-origin: center center;
                        transform: rotate(${angle}deg);
                        -webkit-transform: rotate(${angle}deg);
                        -moz-transform:rotate(${angle}deg);">
                        </div>
                        </div>
                        </div>
                        `,
            /**__-- (!) the only one work-around for rotation, do not change (!) --__**/
        });

        return icon;
    }

    private getStatusMarker(status: VehicleStatusEnum) : number {
        const vehSettings = Consts.VehicleSettingsByStatusMap.get(status);
        return vehSettings ? vehSettings.markerNumber : 0;
    }
}
